var IconButton = require("app/ui/IconButton"),
    kind       = require("enyo/kind"),
    utils      = require("enyo/utils");

require("app/ui/YepNopeMessage.less");

module.exports = kind(/** @lends  app.ui.YepNopeMessage.prototype */ {

    /**
     * @private
     */
    name: "app.ui.YepNopeMessage",

    /**
     * @private
     */
    classes: "app-ui-yep-nope-message",

    /**
     * The name for the command that will bubble up when the yep button gets
     * tapped.
     *
     * @type     {string}
     * @default  "onMessageYepButtonTap"
     * @public
     */
    yepButtonCommand: "onMessageYepButtonTap",

    /**
     * The name for the command that will bubble up when the nope button
     * gets tapped.
     *
     * @type     {string}
     * @default  "onMessageNopeButtonTap"
     * @public
     */
    nopeButtonCommand: "onMessageNopeButtonTap",

    /**
     * @private
     */
    components: [{
        name:       "content",
        classes:    "app-ui-yep-nope-message__content",
        components: [{
            name:    "title",
            classes: "app-ui-yep-nope-message__title",
            tag:     "h2"
        }, {
            name:    "body",
            classes: "app-ui-yep-nope-message__body",
            tag:     "p"
        }, {
            classes:    "app-ui-yep-nope-message__buttons",
            components: [{
                name:    "yepButton",
                kind:    IconButton,
                classes: "app-ui-yep-nope-message__yep-button",
                ontap:   "onYepButtonTap"
            }, {
                name:    "nopeButton",
                kind:    IconButton,
                classes: "app-ui-yep-nope-message__nope-button",
                ontap:   "onNopeButtonTap"
            }]
        }]
    }],

    /**
     * Bubble up a named command for the yep button.
     *
     * @param    {enyo.Control}  sender  The sender
     * @param    {Object}        event   The tap event
     * @returns  {boolean}       Stop propagation of the original event
     * @private
     */
    onYepButtonTap: function(sender, event) {
        var command = this.get("yepButtonCommand"),
            vent;

        vent               = utils.clone(event);
        vent.originator    = sender;
        vent.originalEvent = event;
        delete vent.delegate;
        this.bubble(command, vent);

        // Stop propagation of the original tap
        return true;
    },

    /**
     * Bubble up a named command nope button.
     *
     * @param    {enyo.Control}  sender  The sender
     * @param    {Object}        event   The tap event
     * @returns  {boolean}       Stop propagation of the original event
     * @private
     */
    onNopeButtonTap: function(sender, event) {
        var command = this.get("nopeButtonCommand"),
            vent;

        vent               = utils.clone(event);
        vent.originator    = sender;
        vent.originalEvent = event;
        delete vent.delegate;
        this.bubble(command, vent);

        // Stop propagation of the original tap
        return true;
    }

});
